import './signin.scss';
import React, {Component} from 'react';
import TextBox from "../../../shared/component/textbox/Textbox";
import Validation from "../../../helpers/Validation";
import Login from "../../../core/api/user/Login";
import Storage from "../../../helpers/Storage";
import {withRouter} from "../../../helpers/withRouter";
import config from "../../../config";
import T from "../../../shared/component/t/T";
import logo from "../../../assets/images/logo.svg";
import { _alert } from '../../../actions/Alert';
import { connect } from 'react-redux';
import {handleChangeDirection, handleChangeLang} from "../../../actions/Lang";
import {handleChangeCalendar} from "../../../actions/Calendar";
import {handleChangeDoubleClickAction} from "../../../actions/UserSettings";
import snippets from "../../../helpers/snippets";
import CheckBox from "../../../shared/component/CheckBox/CheckBox";
import {default as _} from "../../../helpers/Translate"
import {_loading} from "../../../actions/Loading";
import ComboBox from "../../../shared/component/ComboBox/ComboBox2";
import BaseApi from "../../../core/api/BaseApi";
import WholeApp from "../../../core/api/WholeApp";
import debounce from "lodash.debounce";
import Button from "../../../shared/component/button/Button";
import {ChangesLog} from "../../../actions/ChangesLog";
import {Tooltip as Tooltp} from 'antd';
import NetworkSpeed from "../../../core/api/NetworkSpeed/NetworkSpeed";
const packageJson = require('../../../../package.json');

const login = new Login();
const baseApi = new BaseApi();
const wholeApp = new WholeApp();
const netSpeed = new NetworkSpeed()

class Signin extends Component {


    input = {
        username: '',
        password: '',
	    otp: ''
    };

    validators = {
        username: ['required'],
        password: ['required'],
	    otp: []
    };

    constructor(props) {
        super(props);

        this.handleInput = this.handleInput.bind(this);
        this.submitForm = this.submitForm.bind(this);
		this.redirect = debounce(this.redirect.bind(this), 1000);

        this.state = {
			language: Storage.getLanguage(),
			loaded: false,
            username: '',
            password: '',
	        otp: '',
            input: this.input,
            errorData: {counter: 0, errors: [], hints:[]},
            serverLoginErrors: [],
            rememberMe: null,
			hospitalOptions: [],
			selectedHospital: -1,
	        isInside: true
        };
    }

	UNSAFE_componentWillMount() {
		baseApi.fullFetch("hospital", "get", {data:{"my_group_mates": true}}).then((response)=>{
			Storage.setHospitals(response.data)
			let selected
			let hospitals = Object.entries(response.data).map(item => {
				if (item[1].current === true) {
					selected = item[0]
					document.title = _.init4("title_loginPage", {hospital: item[1]?.title}, this.state.language);
				}
				return({value: item[0], text: item[1]?.title, id: item[1]?.ip});
			})
			this.setState({hospitalOptions: hospitals, selectedHospital: selected})
		}).catch(()=>{
			this.setState({loaded: false})
		})
	}

	componentDidMount() {
		wholeApp.getData({
			translations: false,
			modalities: true,
			users: false,
			report_headers: true,
			service_code_groups: true,
			dicom_viewers: true,
			configs: true
		}).then(response => {
			Storage.setWebData(response.data);
			Storage.uiVersionSet(packageJson.version)
			this.setState({loaded: true, isInside: response.data?.is_inside}, ()=>{
				if (!this.state.isInside){
					this.validators = {...this.validators, otp: ['required']}
				}
			})
		}).catch(() => {
			this.setState({loaded: false})
		});

        //this line is for remove persistence alerts before this page
        this.props.dispatch(_alert(false, '', ''));

		window.addEventListener('storage', (e) => {
			if (e.key === 'user_info') {
				this.loginHandler()
			}
		});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.language !== this.props.language) {
            this.setState({
                language: this.props.language
            });
        }
    }

    componentWillUnmount() {
		window.removeEventListener("storage", () => {});
    }

	loginHandler = () => {
		let now = Date.parse(new Date())
		let tokenTime = Storage.getTicketTime();
		if (now - tokenTime < 9000){
			this.redirect(Storage.getRedirectAfterLogin())
		}
	}

	redirect = (url) => {
		this.props.navigate(`${url}`);
	}

    handleInput(event) {
        let nam = event.target.name;
        let val = event.target.value;
        Object.assign(this.input, {[nam]: val});

        let someProperty = this.state.errorData
        someProperty.counter = Math.max(0, someProperty.counter-1)
        someProperty.errors[nam] = ""
        someProperty.hints[nam] = ""

		this.setState({
			input: this.input,
			errorData: someProperty,
			serverLoginErrors: [],
		});
	}

    handleRememberMe = (e) => {
        this.setState({rememberMe: e.checked})
    }

	handleSelectedHospital = (e) => {
		if (!snippets.isObjectEmpty(this.state.hospitalOptions[e]?.id)){
			window.location.href = `http://${this.state.hospitalOptions[e].id}/`
		}
    }
	
	speedTest = () => {
		netSpeed.getTime().then((response) => {
			netSpeed.sendTime(response).then((res) => {
				// console.log('net speed send time', response, res)
			})
		})
	}

    submitForm(e) {
        e.preventDefault();
		if (!this.state.loaded) {
			this.props.dispatch(_alert(true, 'info', _.init("not_downloaded_yet_wait", this.state.language)));
			return
		}

		let errors = {
			username: '',
			password: '',
			otp: ''
		};
		let hints = {
			username: '',
			password: '',
			otp: ''
		};
		
		const validationResult = Validation.validate(this.state.input, errors, hints, this.validators);
		this.setState({
			errorData: {
				'counter': validationResult.errorCount,
				'errors': validationResult.errors,
				'hints': validationResult.hints
			}
		});
		if (!validationResult.errorCount) {
			this.props.dispatch(_loading(true))
			login.into(this.state.input).then((response) => {
				// console.log(response)
				if (response.data?.changelogs){
					this.props.dispatch(ChangesLog(response.data?.changelogs));
				}
				if (snippets.isObjectEmpty(Storage.getUsers())){
		            let id =  response.data?.department?.id
		            baseApi.fullFetch("users","get",{ data: {department_id: id}}).then(res => {
		                Storage.setUsers(res.data?.users);
		            })
		        }
				this.speedTest()
				
				Storage.setNewLogin(response, this.state.rememberMe)
				this.props.navigate(`${Storage.getRedirectAfterLogin()}`);
				this.props.dispatch(_alert(true, 'success', response.data.message));
				this.props.dispatch(handleChangeLang(response.data?.configs?.general?.language));
				this.props.dispatch(handleChangeDirection(response.data?.configs?.general?.direction));
				this.props.dispatch(handleChangeCalendar(response.data?.configs?.general?.calendar));
				this.props.dispatch(handleChangeDoubleClickAction(response.data?.configs?.general?.doubleClickAction || config.doubleClickAction));
			}).catch(({response}) => {
				this.setState({
					serverLoginErrors: [response.data?.msg]
				});
			}).finally(() => {
				this.props.dispatch(_loading(false))
			});
		}
	}
	
	otpTooltip = () => {
		return <>
			<p>{_.init('otp_sign_in_info')}</p>
		</>
	}

    render() {
        return (
            <>
                <div className={`sign`} style={{direction: _.direction()}}>
                    <img className={'sign__logo'} src={logo} alt={'spax'}/>
                    <div className={'sign__user'}>
						<ComboBox className={``}
								   type="select"
								   labelText={"select_hospital"}
								   selectedItem={this.state.selectedHospital}
								   comboboxValues={this.state.hospitalOptions}
								   changeValueHandler={this.handleSelectedHospital}
								   show
								   tabIndex={1}
						/>
					</div>
                    <div className={'sign__subtitle'}>
                        <T token={'enter_login'} />
                    </div>

					<form method='POST' onSubmit={this.submitForm}>
						<TextBox changeValue={this.handleInput}
						         errorData={this.state.errorData}
						         name="username"
						         placeholder={''}
						         showMessage={true}
						         showLabel={true}
						         label={<T token={'username'} />}
						         key={0}
						         direction={_.direction()}
								 isAutoFocus={true}
								 tabIndex={2}
						/>

						<TextBox changeValue={this.handleInput}
						         errorData={this.state.errorData}
						         name="password"
						         type="password"
						         showMessage={true}
						         showLabel={true}
						         label={<T token={'password'} />}
						         key={1}
						         direction={_.direction()}
								 tabIndex={3}
						/>
						
						{!this.state.isInside && <div className={'otp'}>
							<TextBox changeValue={this.handleInput}
						         errorData={this.state.errorData}
						         name="otp"
						         type="number"
						         showMessage={true}
						         showLabel={true}
						         label={<T token={'otp'} />}
						         key={2}
						         direction={_.direction()}
								 tabIndex={4}
							/>
							<Tooltp title={()=>this.otpTooltip()}
							        overlayClassName={'otp_tooltip'}
							>
								<i className={'fal fa-circle-question'} />
							</Tooltp>
						</div>}

                        <CheckBox type="complex"
                                  disableMainLabel={true}
                                  name="remember_me"
                                  value={1}
                                  labelText={"remember_me"}
                                  handleChangeValue={this.handleRememberMe}
                                  checked={this.state.rememberMe}
                                  icon={"fal fa-info-circle"}
                                  tooltipWithIcon={_.init("remember_me_hint", this.state.language)}
                                  transparent
								  tabIndex={4}
						/>

                        {!snippets.isObjectEmpty(this.state.serverLoginErrors) &&
                        <div className={'sign__serverError'}>
                            {this.state.serverLoginErrors}
                        </div>}

						<Button className={`sign__action sign__action--primary ${this.state.loaded ? "" : "disabled"}`}
							 	type="submit"
								onClick={this.submitForm}
								title={_.init(!this.state.loaded ? "not_downloaded_yet_wait" : "click_for_login", this.state.language)}
						>
							<T token={'login'} />
						</Button>
					</form>
					<div className={"versions"}>
						<div className={"UI_version"} >
							<T token={"version"} />: <T token={Storage.uiVersionGet()} />
						</div>
						<div className={"packs_version"} >
							<T token={"pacs_version"} />: <T token={Storage.pacsVersionGet()} />
						</div>
					</div>
				</div>
			</>
		);
	}
}

const mapStateToProps = state => {
	const language = state.LangReducer.language;
	const device = state.DeviceModeReducer.mode;
	return {language, device};
}
export default connect(mapStateToProps)(withRouter(Signin));
